<template>
  <eg-b-form-input
    id="essay-search"
    ref="searchInput"
    v-model="text"
    class="pr-4"
    size="sm"
    type="text"
    placeholder="Filter by name"
    @input="changeText"
    v-on="$listeners"
  ></eg-b-form-input>
</template>

<script>
import debounce from "@/utils/debounce";

export default {
  name: "InputFilter",
  props: ["value"],

  data() {
    return {
      oldText: "",
      text: "",
    };
  },

  methods: {
    changeText: debounce(function (value = "") {
      if (
        value.length >= 2 ||
        (this.oldText.length >= 2 && value.length === 0)
      ) {
        this.oldText = value;
        this.$emit("input", value);
      }
    }, 500),
  },
};
</script>
